export type MathJaxTypes = {
  label: string;
  firstString: string;
  laststring: string;
};

export const mathJaxCodes: MathJaxTypes[] = [
  {
    label: 'Mjx',
    firstString: `\\(`,
    laststring: `\\)`,
  },
  {
    label: 'Mjx[]',
    firstString: `\\[`,
    laststring: `\\]`,
  },
  {
    label: 'Br',
    firstString: '<br>',
    laststring: '',
  },
  {
    label: 'B',
    firstString: '<b>',
    laststring: '</b>',
  },
  {
    label: 'Eqn',
    firstString: `\\begin{align*} \n`,
    laststring: `&=  \\\\ 
 &=  \\\\ 
 \\end{align*}`,
  },
  {
    label: 'a/b',
    firstString: `\\frac{`,
    laststring: `}{}`,
  },
  {
    label: 'A/B',
    firstString: `\\dfrac{`,
    laststring: `}{}`,
  },
  {
    label: 'ol',
    firstString: `<ol>\n<li>`,
    laststring: `</li>\n</ol>`,
  },
  {
    label: 'ul',
    firstString: `<ul>\n<li>`,
    laststring: `</li>\n</ul>`,
  },
  {
    label: 'li',
    firstString: `<li>`,
    laststring: `</li>`,
  },
  {
    label: 'sqrt',
    firstString: '\\sqrt{',
    laststring: '}',
  },
  {
    label: 'rad',
    firstString: '\\sqrt[',
    laststring: ']{}',
  },
  {
    // label: '&#x2194;',
    label: '<->',
    firstString: '\\overleftrightarrow{',
    laststring: '}',
  },
  {
    label: 'Seg',
    firstString: '\\overline{',
    laststring: '}',
  },
  {
    label: 'Cong',
    firstString: '\\cong',
    laststring: '',
  },
  {
    label: 'Arr',
    firstString: '\\overrightarrow{',
    laststring: '}',
  },
  {
    label: 'Ang',
    firstString: '\\angle {',
    laststring: '}',
  },
  {
    label: 'X',
    firstString: '\\times ',
    laststring: '',
  },
  {
    label: '.',
    firstString: '\\cdot ',
    laststring: '',
  },
  {
    label: 'CNL',
    firstString: '\\cancel{',
    laststring: '}',
  },
  {
    label: '()',
    firstString: '\\left( ',
    laststring: '\\right)',
  },
];
